import { Component } from '@angular/core';

@Component({
  selector: 'app-service-unavailable-screen',
  standalone: true,
  templateUrl: './service-unavailable-screen.component.html',
})
export class ServiceUnavailableScreenComponent {
  readonly footerText = `© ${new Date().getFullYear()} smzh ag. Alle Rechte vorbehalten.`;
}
